import React, { useState } from "react";
import { useWishlist } from "../context/WishlistContext";
import Banner from "./Banner"; // ✅ import your existing banner component

export default function WishlistButton({ product, className = "" }) {
  const { isInWishlist, addToWishlist, removeFromWishlist } = useWishlist();

  const [banner, setBanner] = useState({ show: false, type: "", message: "" });

  if (!product?._id || product.inStock === false) return null;

  const isWishlisted = isInWishlist(product._id);

  const handleToggle = async (e) => {
    e.stopPropagation();

    if (isWishlisted) {
      // Removing from wishlist can remain synchronous if you trust it
      removeFromWishlist(product._id);
      showBanner("error", `"${product.name}" removed from wishlist`);
    } else {
      // Await the context function to ensure auth and success
      const success = await addToWishlist(product);
      if (success) {
        showBanner("success", `"${product.name}" added to wishlist`);
      }
      // If not success (e.g., not logged in), addToWishlist already handles alert/redirect
    }
  };

  const showBanner = (type, message) => {
    setBanner({ show: true, type, message });
    setTimeout(() => {
      setBanner({ show: false, type: "", message: "" });
    }, 3000);
  };

  return (
    <>
      {banner.show && <Banner type={banner.type} message={banner.message} />}

      <button
        onClick={handleToggle}
        className={`absolute top-2 right-2 bg-white bg-opacity-80 rounded-full p-1 transition ${
          isWishlisted ? "text-red-600" : "text-gray-600 hover:text-red-600"
        } ${className}`}
        aria-label={isWishlisted ? "Remove from Wishlist" : "Add to Wishlist"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 transition duration-300"
          fill={isWishlisted ? "currentColor" : "none"}
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
          />
        </svg>
      </button>
    </>
  );
}
